import { MaskedLines } from "./Reveal";

/**
 * Premium page hero with an optimized, subtle background image and a
 * purple-dominant overlay treatment. One image per route = fast loads.
 */
export default function PageHero({ eyebrow, image, lines, children, className = "" }) {
  return (
    <section className={`relative pt-44 lg:pt-71.8 pb-44 lg:pb-20 px-6 lg:px-12 bg-brand-bg overflow-hidden ${className}`}>
      {/* Background image — kept subtle so text stays clean */}
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          aria-hidden="true"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          className="w-full h-full object-cover opacity-[0.20] mix-blend-luminosity"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(20,18,22,0.72) 0%, rgba(20,18,22,0.55) 40%, var(--bg) 100%)",
          }}
        />
      </div>

      {/* Purple ambient glow (dominant) */}
      <div
        className="absolute -top-40 right-[-10%] w-[60vw] h-[50vw] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(102,76,221,0.32), transparent 60%)" }}
      />
      {/* Small mint spark, low opacity */}
      <div
        className="absolute bottom-[-20%] left-[-10%] w-[40vw] h-[40vw] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(17,245,186,0.10), transparent 65%)" }}
      />
      <div className="absolute inset-0 grain opacity-25" />

      <div className="max-w-[1600px] mx-auto relative">
        <p className="eyebrow mb-6 flex items-center gap-3">
          <span className="w-8 h-px bg-brand-purple" /> {eyebrow}
        </p>
        <h1 className="font-display text-[12vw] lg:text-[9vw] leading-[1.25] tracking-tighter uppercase">
          <MaskedLines lines={lines} />
        </h1>
        {children}
      </div>
    </section>
  );
}
